<template>
  <div class="customer-list clearfix">
    <Search @getHeight="getHeight"
            @add="addCustomer()"
            @sort="sortCustomer()"
            @saveSet="saveSet"
            :isquery="true"
            :advancedQuery="true"
            :tableConfig="tableConfig"
            :tableName="tableName"
            :isDel="true"
            :delPara="delPara"
            :functionBtn="true"
            :showSort="false"
            :sortPara="sortPara"
            ref="Search"
            searchName="getCustomerList">
      <template v-slot:left>
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input v-model="searchForm.keyWord"
                      clearable
                      @keyup.enter.native="$refs.Search.handleSearch"
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center>
        <el-button size="mini"
                   icon="el-icon-back"
                   type="warning"
                   plain
                   v-if="verifyPermission('Update') && $route.query.needBack"
                   @click="$router.go(-1)">返回招聘报名</el-button>
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="5"
                :md="6"
                :sm="12"
                :xs="24">
          <el-form-item label="状态"
                        prop="isEnabled">
            <el-select v-model="searchForm.isEnabled"
                       clearable
                       placeholder="请选择状态">
              <el-option label="启用"
                         :value="false"></el-option>
              <el-option label="停用"
                         :value="true"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8"
                :md="10"
                :sm="12"
                :xs="24">
          <!-- <el-form-item label="合同日期">
            <el-col :span="11">
              <el-date-picker style="width: 100%"
                              v-model="searchForm.startTime"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择开始日期">
              </el-date-picker>
            </el-col>
            <el-col :span="2">~</el-col>

            <el-col :span="11">
              <el-date-picker style="width: 100%"
                              v-model="searchForm.endTime"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-col>
          </el-form-item> -->
        </el-col>
      </template>
    </Search>
    <div class="customer-table-list fr page">
      <MyTable @editCustomerInfo="editCustomerInfo"
               @selectChange="onlyChange"
               @inputChange="onlyChange"
               @selectionChange="selectionChange"
               :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight"
               tableEmptyText="暂无数据，点击新增"
               @EmptyBtn="addCustomer"
               tableType="selection"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:isEnabled="slotData">
          <el-tag size="small"
                  type="danger"
                  v-if="slotData.scope.row.isEnabled">停用</el-tag>
          <el-tag size="small"
                  type="success"
                  v-else>启用</el-tag>
        </template>
        <template v-slot:startTime="slotData">
          {{
            slotData.scope.row.startTime &&
            slotData.scope.row.startTime.slice(0, 10)
          }}
        </template>
        <template v-slot:endTime="slotData">
          {{
            slotData.scope.row.endTime &&
            slotData.scope.row.endTime.slice(0, 10)
          }}
        </template>
        <template v-slot:sort="slotData">
          <el-input-number size="small"
                           :precision="0"
                           v-model="slotData.scope.row.sort"
                           controls-position="right"
                           @change="slotData.scope.row.add = '1'"></el-input-number>
        </template>

        <template v-slot:operation="slotData">
          <el-button @click="editCustomerInfo(slotData.scope.row,'pos')"
                     plain
                     size="small"
                     icon="el-icon-edit"
                     v-if="verifyPermission('Update')">编辑</el-button>
          <el-button @click="imageManage(slotData.scope.row)"
                     plain
                     size="small"
                     type="primary"
                     icon="el-icon-edit"
                     v-if="verifyPermission('Update')">企业图册</el-button>
          <!-- <el-button @click="editCustomerInfo(slotData.scope.row,'aontract')"
                     plain
                     size="small"
                     icon="el-icon-s-order"
                     v-if="verifyPermission('Update')">合同管理</el-button> -->
          <!-- <el-button
            @click="deleteCustomer(slotData.scope.row.id)"
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            v-if="verifyPermission('Update')"
            >删除</el-button
          > -->
          <!-- <el-dropdown style="margin-left: 10px"
                       trigger="click"
                       @command="handleCommand">
            <el-button type="primary"
                       plain
                       size="small">更多 <i class="el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-picture-outline"
                                :command="{ command: 'image', row: slotData.scope.row }"
                                v-if="verifyPermission('Add')">企业图册</el-dropdown-item>

              <el-dropdown-item divided
                                icon="el-icon-circle-plus-outline"
                                :command="{ command: 'add', row: slotData.scope.row }"
                                v-if="verifyPermission('Add')">新增职位</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </template>
      </MyTable>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="getCustomerList"
                  ref="pagination" />
    </div>
    <AddCustomer :drawerShow="addCustomerDrawerShow"
                 :title="drawerTitle"
                 :operation="operation"
                 :customerInfo="customerInfo"
                 :industryData="industryData"
                 :cityList="cityList"
                 @colseDrawer="addCustomerDrawerShow = false"
                 @refreshData="
        () => {
          getCustomerList();
          // getCustomerLevelClassData();
        }
      " />
    <!-- <AddOnSite
      :drawerShow="addOnSiteShow"
      :title="drawerTitle"
      :operation="operation"
      :customerInfo="customerInfo"
      :industryData="industryData"
      :users="users"
      @colseDrawer="addOnSiteShow = false"
      @refreshData="
        () => {
          getCustomerList();
          // getCustomerLevelClassData();
        }
      "
    /> -->
    <AddPosition :drawerShow="addPositionDrawerShow"
                 :companyId="companyId"
                 :cityList="cityList"
                 operation="add"
                 @colseDrawer="addPositionDrawerShow = false"
                 @refreshData="getCustomerList" />

    <ImageManage :visible.sync="imageManageVisible"
                 :row="currentRow" />
    <AontractManage :drawerShow="aontractDrawerShow"
                    @colseDrawer="aontractDrawerShow = false"
                    :customerInfo="customerInfo"
                    @refreshData="getCustomerList" />
  </div>
</template>

<script>
import AddCustomer from "./AddCustomer";
// import AddOnSite from "./AddOnSite";
import AontractManage from "./AontractManage.vue";
import AddPosition from "../position_center/AddPosition.vue";

import MyTable from "@/components/Table";
import ImageManage from "./ImageManage";
import Search from "@/components/Search";

import { verifyPermissionMinix } from "@/utils/mixin";

export default {
  components: {
    Search,
    // AddOnSite,
    AddCustomer,
    AddPosition,
    MyTable,
    AontractManage,
    ImageManage,
  },
  mixins: [verifyPermissionMinix],

  data () {
    return {
      sortPara: {
        data: "",
        controller: "customer",
        action: "sort",
        callback: "getCustomerList",
      },
      tableName: "CustomerListTable",
      cityList: [],
      tableConfig: [
        {
          field: "fullName",
          label: "企业名称",
          flag: true,
          minWidth: 190,
          align: "center",
        },
        {
          field: "shortName",
          label: "企业简称",
          minWidth: 160,
          flag: true,
          align: "center",

        },
        {
          field: "address",
          label: "企业地址",
          flag: true,
          align: "center",

        },
        {
          field: "theContact",
          label: "联系人",
          align: "center",
          width: 160,
          flag: true,
        },
        {
          field: "contactNumber",
          label: "手机号码",
          align: "center",
          width: 160,
          flag: true,
        },
        {
          field: "isEnabled",
          label: "状态",
          minWidth: 30,
          align: "center",
          slotName: "isEnabled",
          flag: true,
          width: 100,
        },

        {
          label: "基本操作",
          slotName: "operation",
          width: 210,
          align: "center",
          fixed: "right",
          flag: true,
        },
      ],
      tabList: [],
      tabIndex: 0,
      addOnSiteShow: false,
      addPositionDrawerShow: false,
      aontractDrawerShow: false,
      addCustomerDrawerShow: false,
      imageManageVisible: false,
      currentRow: null,
      drawerTitle: "",
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {},
      customerIds: [],
      customerInfo: null,
      operation: "",
      companyId: "",
      industryData: [],
      reminder: "",
      delPara: {
        data: "",
        controller: "EnterpriseInfo",
        action: "Delete",
        callback: "getCustomerList",
      },
      remindType: "",
      hidden: false,
      tableHeight: "",
    };
  },
  computed: {},
  mounted () {
    this.getCustomerList();
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  methods: {
    onlyChange (value, field, row) {
      let sendData = {
        id: row.id,
        fieldName: field,
        fieldValue: value,
      };
      this.$api.customer.FactoryOneselfFieldChange(sendData).then((res) => {
        if (res.error) {

        }
      });
    },
    // 列的显示与隐藏
    saveSet (checkList, type) {

      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    //多选
    selectionChange (selection) {
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },

    //单个编辑
    singleEdit (value, field, row) {
      let sendData = {
        id: row.id,
      };
      sendData[field] = value;
      this.$api.customer.addFactory(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("保存职位信息成功");
        } else {
          this.$message.error("保存职位信息失败");
        }
      });
    },
    //获取子组件高度
    getHeight (height) {
      this.tableHeight = height;
    },

    //排序
    sortCustomer () {
      let arr = [];
      let obj = {};
      this.tableData.forEach((element) => {
        if (element.add == "1") {
          obj.id = element.id;
          obj.sort = element.sort ? element.sort : "";
          arr.push(obj);
          obj = {};
        }
      });
      this.$api.customer.sort(arr).then((res) => {
        if (res.error === false) {
          this.getCustomerList();
          this.$message.success("更新成功");
        }
      });
    },
    //获取数据
    getCustomerList () {
      this.loading = true;
      const sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        wheres: [
          {
            name: "isEnabled",
            value: this.searchForm.isEnabled !== undefined ? String(this.searchForm.isEnabled) : '',
            expressionType: 'Equal',
          },
          {
            name: "keyword",
            value: this.searchForm.keyWord,
            expressionType: 'Like',
          },
        ],
      };
      this.$api.EnterpriseInfo.PageData(sendData).then((res) => {
        if (res.error === false) {
          this.loading = false;
          this.tableData = res.data.data;
          this.sortPara.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    // 添加客户
    addCustomer (event) {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增企业";
    },
    // 删除公司
    deleteCustomer (ids) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.posts.GetPositionByCid(ids).then((res) => {

            if (res.error === false) {
              if (res.data.length >= 1) {
                this.$message.error("该企业有设置职位，请删除职位后再操作");
              } else {
                this.$api.customer.deleteFactory(ids).then((res) => {

                  if (res.error === false) {
                    this.getCustomerList();
                    this.$message.success("删除成功");
                  }
                });
              }
            }
          });
        })
        .catch(() => { });
    },
    getCustomerDetails (id) {
      return new Promise((resolve, reject) => {
        this.$api.EnterpriseInfo.Detail({ id }).then((res) => {

          if (res.error === false) {
            resolve(res.data);
          } else {
            reject("error");
          }
        });
      });
    },
    // 打开添加驻场界面
    addOnSite (row) {
      this.operation = "check";
      this.addOnSiteShow = true;
      this.customerInfo = row;
    },
    // 修改公司信息
    editCustomerInfo (row, flag) {
      this.getCustomerDetails(row.id).then((res) => {
        if (res) {
          if (flag == 'pos') {

            this.operation = "edit";
            this.addCustomerDrawerShow = true;
            this.drawerTitle = "修改企业信息";
            this.customerInfo = res;
          } else {
            this.operation = "edit";
            this.aontractDrawerShow = true;
            this.customerInfo = res;
          }

        }
      });
    },
    // 打开添加职位界面
    addPosition (companyId) {
      this.companyId = companyId;

      this.addPositionDrawerShow = true;
    },
    // 打开添加图片界面
    imageManage (row) {
      this.imageManageVisible = true;
      this.currentRow = row;
    },

    handleBatchCommand (command) {
      switch (command) {
        case "delete":
          this.deleteCustomer(this.customerIds);
          break;
      }
    },
    handleCommand (command) {
      switch (command.command) {
        case "delete":
          this.deleteCustomer(command.row.id);
          break;
        case "edit":
          this.editCustomerInfo(command.row);
          break;
        case "add":
          this.addPosition(command.row.id);
          break;
        case "image":
          this.imageManage(command.row);
          break;
        case "check":
          this.addOnSite(command.row);
          break;
      }
    },
  },
};
</script>

<style lang="less">
// .el-form-item__label {
//   width: 60px !important;
// }
.top-buttons {
  transition: 1s;
}

.el-dropdown-link {
  margin-right: 10px;
}
.btn {
  margin-left: 15px;
}
.customer-list {
  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 140px);
  }
}
</style>
